var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.serviceList.length > 0 ? _c('div', {
    staticClass: "packageWrap"
  }, [_c('div', {
    staticClass: "packageLeft"
  }, [_vm.businessType == 'COMPANY_INCORPORATION' ? _c('p', {
    staticClass: "fs14 fwb mb6"
  }, [_vm._v("Customize - Incorporation")]) : _vm._e(), _vm.businessType == 'SERVICE_TRANSFER' ? _c('p', {
    staticClass: "fs14 fwb mb6"
  }, [_vm._v("Customize - Service Transfer")]) : _vm._e(), _c('p', [_c('span', {
    staticClass: "fs20 fwb orange"
  }, [_vm._v(_vm._s(_vm.serviceListPriceSum(_vm.serviceList, _vm.serviceList[0].currency)))])]), _vm._m(0)]), _c('div', {
    staticClass: "packageRight"
  }, [_c('div', {
    staticClass: "flex flex-direction-row details"
  }, [_c('div', {
    staticClass: "mr20"
  }, [_c('p', {
    staticClass: "fs12 fwb"
  }, [_vm._v("Package Includes:")]), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l(_vm.serviceList, function (son) {
    return _c('li', {
      key: "son-".concat(son.id)
    }, [_c('span', {
      staticClass: "fwb green fs12 el-icon-check"
    }), _vm._v(" " + _vm._s(son.description) + " "), _vm.$isNumberLike(son.serviceFee) ? _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(son.currency, son.serviceFee)) + ")")]) : _vm._e(), son.serviceScope ? _c('el-popover', {
      attrs: {
        "placement": "bottom",
        "trigger": "hover"
      }
    }, [_c('span', {
      staticClass: "fs12"
    }, [_vm._v(_vm._s(son.serviceScope))]), _c('span', {
      staticClass: "ml2 fs13 blackD8 el-icon-question",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    })]) : _vm._e()], 1);
  }), 0)]), _c('div', {
    staticClass: "mr20"
  }, [_vm._m(1), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l(_vm.mergeSameAttrList(_vm.serviceList, 'thirdPartyFeeDescription', 'thirdPartyFee'), function (part) {
    return _c('li', {
      key: "part-".concat(part.id)
    }, [part.thirdPartyFeeDescription ? _c('span', [_vm._v("- " + _vm._s(part.thirdPartyFeeDescription))]) : _vm._e(), _vm.$isNumberLike(part.thirdPartyFee) ? _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(part.currency, part.thirdPartyFee)) + ")")]) : _vm._e()]);
  }), 0)]), _c('div', [_vm._m(2), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l(_vm.mergeSameAttrList(_vm.serviceList, 'otherFeeDescription', 'otherFee'), function (other) {
    return _c('li', {
      key: "other-".concat(other.id)
    }, [other.otherFeeDescription ? _c('span', [_vm._v("- " + _vm._s(other.otherFeeDescription))]) : _vm._e(), _vm.$isNumberLike(other.otherFee) ? _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(other.currency, other.otherFee)) + ")")]) : _vm._e()]);
  }), 0)])])])]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pt10"
  }, [_c('p', {
    staticClass: "fs12"
  }, [_vm._v("Exclusive for:")]), _c('p', {
    staticClass: "fs12 black88"
  }, [_vm._v("Customers who wish to choose services flexibly.")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "fs12 pt18 lh22"
  }, [_c('span', {
    staticClass: "fwb green fs12 el-icon-check"
  }), _vm._v(" Third Party Fee: ")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "fs12 pt18 lh22"
  }, [_c('span', {
    staticClass: "fwb green fs12 el-icon-check"
  }), _vm._v(" Other Fee: ")]);
}]

export { render, staticRenderFns }